module.exports = (__webpack_require__("8wy/"))("xYSL");